// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"11a20df1","545":"b3ba8a86","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};